import React from "react";
import { BsShop } from "react-icons/bs";
import { FiHome } from "react-icons/fi";
import { GoPlus } from "react-icons/go";

export const Delivery = ({ handleMethod, activeMethod, delivery }) => {
  const Card = ({ data }) => {
    return (
      <div
        role="button"
        tabIndex={0}
        className={` ${
          activeMethod && activeMethod.findIndex((item) => item.shippingMethodId === data.delivery.shippingMethodId) !== -1
            ? "cardPayment cardPaymentActive"
            : "cardPayment"
        } ${data.delivery.shippingMethodId === undefined ? "newDeliveryOption" : ""}`}
        onClick={() => handleMethod(data.delivery)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleMethod(data.delivery);
          }
        }}
        aria-pressed={activeMethod && activeMethod.findIndex((item) => item.shippingMethodId === data.delivery.shippingMethodId) !== -1}
      >
        <div>{data.icon}</div>
        <div>{data.name}</div>
      </div>
    );
  };

  return (
    <>
      {delivery.homeDeliveryIsActive && (
        <Card data={{ name: delivery.nameHomeDelivery, icon: delivery.shippingMethodId ? <FiHome /> : <GoPlus />, delivery: delivery }} />
      )}
      {delivery.storeDeliveryIsActive && (
        <Card data={{ name: delivery.nameStoreDelivery, icon: delivery.shippingMethodId ? <BsShop /> : <GoPlus />, delivery: delivery }} />
      )}
    </>
  );
};
